import { useQuery } from 'react-query'

import { Task } from '../components/Task'
import { api } from '../../../../services/api'
import { type TaskDomain } from '../../../../types/domain/task-domain'
import { Spinner } from '../../../../components/Spinner'

export const MyTasks = () => {
  const { data: tasks, isLoading } = useQuery<TaskDomain[]>(
    ['my-tasks'],
    async () => {
      const response = await api.get('/tasks/my')
      return response.data
    }
  )

  return (
    <div className="my-10 lg:my-14">
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          {tasks?.length === 0 ? (
            <p className="text-lg text-grey-500">
              Sem tasks associadas a este usuário.
            </p>
          ) : (
            <div className="flex flex-col gap-2 max-h-[80vh] overflow-auto scrollbar pr-4">
              {tasks?.map((task) => (
                <Task key={task.id} task={task} />
              ))}
            </div>
          )}
        </>
      )}
    </div>
  )
}
